import PreloadUser from '../models/PreloadUser';

export async function fetchPreloadUserByData(id: string, name: string, email: string, phone: string): Promise<PreloadUser> {
	const response = await fetch(`api/webchat/${id}/preload/${name}/${email}/${phone}`);
	if (!response.ok) {
		throw Error(response.statusText);
	}

    return response.json();
}